@if (showAddProgram()) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-program
  [selectedPatient]="selectedPatient"
    (close)="onCloseAddProgram($event)"
  />
</dialog>
} @if (showAddPlaylist()) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-playlist
    [selectedPatient]="selectedPatient"
    (close)="onCloseAddPlaylist($event)"
  />
</dialog>
} @if (showAddTarget()) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-target
    [selectedPatient]="selectedPatient"
    (close)="onCloseAddTarget($event)"
    [addingTargetToProgramID]="addingTargetToProgramID"
  />
</dialog>
} @if (showAddStaffAlert()) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-staff-alert (close)="onCloseAddStaffAlert($event)" />
</dialog>
} @if (showAddSkillArea()) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-skill-area
    (close)="onCloseAddSkillArea($event)"
    [selectedPatient]="selectedPatient"
  />
</dialog>
} @if (showAddReminder() && selectedPatient) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-reminder
    [selectedPatient]="selectedPatient"
    (close)="onCloseAddReminder($event)"
  />
</dialog>
} @if (showAddBehavior()) {
<div class="supervisor-dialog-backdrop"></div>
<dialog class="supervisor-dialog" open>
  <app-add-behavior
    [selectedPatient]="selectedPatient"
    (close)="onCloseAddBehavior($event)"
  />
</dialog>
}

<div class="dashboard">
  <top-bar></top-bar>
  <div class="modules-container">
    <div class="horizontal-flex-list" id="supervisorComponentsList">
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'overview']"
        routerLinkActive="selected"
      >
        <span>Overview</span>
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'skillAreas']"
        routerLinkActive="selected"
      >
        <span>Skill Areas</span>
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'playlists']"
        routerLinkActive="selected"
      >
        <span>Playlists</span>
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'programs']"
        routerLinkActive="selected"
      >
        <span>Programs</span>
        <!-- <div
          class="badge"
          style="
            background-color: #9382ad;
            color: white;
            width: 20px;
            height: 20px;
            border: 0px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-left: 2px;
            cursor: pointer;
            margin-top: -12px;
          "
          (click)="openProgramsHelp()"
        >
          ?
        </div> -->
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'targets']"
        routerLinkActive="selected"
      >
        <span>Targets</span>
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'behaviors']"
        routerLinkActive="selected"
      >
        <span>Behaviors</span>
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'instructions']"
        routerLinkActive="selected"
      >
        <span>Instructions</span>
      </a>
      <a
        class="main-button"
        [routerLink]="['/supervisor', selectedPatient?.ID, 'notes']"
        routerLinkActive="selected"
      >
        <span>Notes</span>
      </a>

      <p-button
        (onClick)="bip.toggle($event)"
        [ngClass]="{ 'main-button': true, selected: false }"
        label="BIP"
        id="moreComponentsButton"
        [style]="{
          'background-color': getMoreButtonBackgroundColor(),
          color: getMoreButtonTextColor(),
          border: 'none',
          padding: '5px 12px',
          'border-radius': '5px',
          'font-size': '22px',
          'font-weight': 'bold'
        }"
      />
      
      <p-button
        (onClick)="op.toggle($event)"
        [ngClass]="{ 'main-button': true, selected: isAnyMoreRouteActive }"
        label="More"
        id="moreComponentsButton"
        [style]="{
          'background-color': getMoreButtonBackgroundColor(),
          color: getMoreButtonTextColor(),
          border: 'none',
          padding: '5px 12px',
          'border-radius': '5px',
          'font-size': '22px',
          'font-weight': 'bold'
        }"
      />

      <p-overlayPanel #op>
        
        <div class="side-menu-buttons">
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'antecedents']"
            routerLinkActive="selected"
          >
            <span>Antecedents</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'consequences']"
            routerLinkActive="selected"
          >
            <span>Consequences</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'reminders']"
            routerLinkActive="selected"
          >
            <span>Reminders</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'prompt-codes']"
            routerLinkActive="selected"
          >
            <span>Prompt Codes</span>
          </a>
          <a
            class="main-button"
            [routerLink]="[
              '/supervisor',
              selectedPatient?.ID,
              'prompt-schedules'
            ]"
            routerLinkActive="selected"
          >
            <span>Prompt Schedules</span>
          </a>
          <a
          class="main-button"
          [routerLink]="[
            '/supervisor',
            selectedPatient?.ID,
            'probe-criteria'
          ]"
          routerLinkActive="selected"
        >
          <span>Probe Criteria</span>
        </a>
          <a
            class="main-button"
            [routerLink]="[
              '/supervisor',
              selectedPatient?.ID,
              'mastery-criteria'
            ]"
            routerLinkActive="selected"
          >
            <span>Mastery Criteria</span>
          </a>
          
          <a
            class="main-button"
            [routerLink]="[
              '/supervisor',
              selectedPatient?.ID,
              'maintanance-criteria'
            ]"
            routerLinkActive="selected"
          >
            <span>Maintenance Criteria</span>
          </a>
         
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'import-data']"
            routerLinkActive="selected"
          >
            <span>Import Data</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'management-report']"
            routerLinkActive="selected"
          >
            <span>Staff Management Report</span>
          </a>
          @if (hasMergeTargetsPermission()) {
            <a
              class="main-button"
              [routerLink]="['/supervisor', selectedPatient?.ID, 'merge-targets']"
              routerLinkActive="selected"
            >
              <span>Merge Targets</span>
            </a>
            <a
              class="main-button"
              [routerLink]="['/supervisor', selectedPatient?.ID, 'merge-behaviors']"
              routerLinkActive="selected"
            >
              <span>Merge Behaviors</span>
            </a>
            <a
              class="main-button"
              [routerLink]="['/supervisor', selectedPatient?.ID, 'move-session-data']"
              routerLinkActive="selected"
            >
              <span>Move Session Data</span>
            </a>
          }
          
          <a
            class="main-button"
            [routerLink]="['/staff','preview', selectedPatient?.ID ]"
            routerLinkActive="selected"
          >
            <span>Preview Session</span>
          </a>
        </div>
      </p-overlayPanel>
      <p-overlayPanel #bip>
        <div class="side-menu-buttons">          
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'BIP','QuickReference']"
              routerLinkActive="selected"
          >
            <span>Quick Reference</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'BIP','Behaviors']"
            routerLinkActive="selected"            
          >
            <span>Behaviors</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'BIP','CrisisCycle']"
            routerLinkActive="selected"
          >
            <span>Crisis Cycle</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'BIP','EmergencyProcedures']"
            routerLinkActive="selected"
          >
            <span>Emergency Procedures</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'BIP','AdditionalInfo']"
            routerLinkActive="selected"
          >
            <span>Additional Info</span>
          </a>
          <a
            class="main-button"
            [routerLink]="['/supervisor', selectedPatient?.ID, 'BIP','List']"
            routerLinkActive="selected"
          >
            <span>List BIPs</span>
          </a>
          
        </div>
      </p-overlayPanel>
    </div>

    <p-divider
      class="mx-3"
      [ngStyle]="{ color: '#719eb6' }"
      styleClass="divider-custom"
    />

    <router-outlet (activate)="activated($event)"></router-outlet>
  </div>
</div>

@if (loading) {
<app-loading-indicator />
}
